import SvgCrossTooltip from '@chilipiper/icons/src/CrossTooltip'
import React from 'react'
import { UnstyledButton } from '../../button'
import { Flex } from '../../../new/core-components/box'
import { Icon } from '../../icon'

interface Props {
  onClose: () => void
}

/**
 * @deprecated - Use ConfirmationModal, ConfigurationModal or Modal from
 *   `@chilipiper/design-system/src/new` instead
 */
export const ModalCloseButton = ({ onClose }: Props) => {
  return (
    <UnstyledButton
      onClick={onClose}
      position='absolute'
      top={4}
      right={4}
      w={7}
      data-test-id='ModalCloseButton'
      data-chili-css='ModalCloseButton'
    >
      <Flex
        w={7}
        h={7}
        borderRadius='full'
        alignItems='center'
        justifyContent='center'
        bg='icon/action-minor'
      >
        <Icon icon={SvgCrossTooltip} alt='Close page button' w={3} h={3} color='white' />
      </Flex>
    </UnstyledButton>
  )
}
